import { render, staticRenderFns } from "./paperAnalysis.vue?vue&type=template&id=11b64d48&scoped=true"
import script from "./paperAnalysis.vue?vue&type=script&lang=js"
export * from "./paperAnalysis.vue?vue&type=script&lang=js"
import style0 from "./paperAnalysis.vue?vue&type=style&index=0&id=11b64d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b64d48",
  null
  
)

export default component.exports